// extracted by mini-css-extract-plugin
module.exports = {"inner":"quote_inner__Z1IBT"};